import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import {
  NgbModal,
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import { SharedService } from '../../../Services/shared.service';
import { LoaderComponent } from "../../loader/loader.component";
import { NoDataFoundComponent } from "../../no-data-found/no-data-found.component";
 
@Component({
  selector: 'app-city',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    NgbPaginationModule,
    NgbTooltipModule,
    RouterLink,
    LoaderComponent,
    NoDataFoundComponent
],
  templateUrl: './city.component.html',
  styleUrls: ['./city.component.css'],
})
export class CityComponent implements OnInit {
  createCityForm: FormGroup;
  cityData: any;
  originalTableData: any;
  cityNames: any[] = [];
  isCityFilterVisible = false;
  isPageloading = false;
  isEditMode: boolean = false;
  searchKey:any
 
  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;
 
  // ---------------------- Filter ---------------------- //
  selectedFilterStatus = '';
 
  // ---------------------- City Status ---------------------- //
  cityId: any;
  cityName: any;
  cityStatus: any;
  currentCityForStatusChange: any = null;
  selectedCityId: any;
  loginData: any;
  isLoading: boolean = false
  pageSizeOptions = [5, 10, 25, 50, 100];
 
  constructor(
    private fb: FormBuilder,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private sharedService: SharedService
  ) {
    this.createCityForm = this.fb.group({
      cityName: [
        '',
        [Validators.required, Validators.pattern('^[A-Za-z\\s]*$')],
      ],
      latandlng: ['', [Validators.required]],
    });
  }
 
  // ----------------------------- Add Coordinates ----------------------------- //
 
  get coordinates(): FormArray {
    return this.createCityForm.get('coordinates') as FormArray;
  }
 
  addCoordinate(): void {
    // this.coordinates.push(this.createCoordinateGroup());
  }
 
  // Method to remove a coordinate group
  removeCoordinate(index: number): void {
    this.coordinates.removeAt(index);
  }
 
  // ----------------------------- ONINIT ----------------------------- //
 
  ngOnInit() {
    this.loginData = this.sharedService.getLoginData();
    this.getCityList();
  }
 
  // ----------------------------- Get City List API ----------------------------- //
 
  getCityList() {
    this.isPageloading = true;
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.isPageloading = false;
        this.cityData = response.body.details;
        console.log(this.cityData);
        this.originalTableData = [...this.cityData];
        this.cityNames = this.cityData.map((city: any) => city.cityName);
      },
      error: (error) => {
        this.isPageloading = false;
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }
 
  getStatus(status: any): string {
    switch (status) {
      case true:
      case 'true':
      case 1:
        return 'Active';
      case false:
      case 'false':
      case 0:
        return 'Inactive';
      default:
        return 'Unknown';
    }
  }
 
  // ----------------------------- Filter Cities ----------------------------- //
 
  filterCities(status: string): void {
    this.selectedFilterStatus = status;
 
    if (status === 'all') {
      this.cityData = [...this.originalTableData]; // Reset to original data
    } else {
      this.cityData = this.originalTableData.filter((city: any) => {
        if (status === 'active') {
          return (
            city.cityStatus === true ||
            city.cityStatus === 'true' ||
            city.cityStatus === 1
          );
        } else if (status === 'inactive') {
          return (
            city.cityStatus === false ||
            city.cityStatus === 'false' ||
            city.cityStatus === 0
          );
        }
        return true;
      });
    }
  }
 
  // ----------------------------- Filter Cities by Name ----------------------------- //
 
  filterCitiesByName(selectedCityName: string): void {
    if (selectedCityName) {
      this.cityData = this.originalTableData.filter((city: any) =>
        city.cityName.toLowerCase().includes(selectedCityName.toLowerCase())
      );
    } else {
      this.cityData = [...this.originalTableData];
    }
    this.isCityFilterVisible = false;
  }
 
  // ----------------------------- Toggle City Filter Dropdown ----------------------------- //
 
  toggleCityFilterDropdown() {
    this.isCityFilterVisible = !this.isCityFilterVisible;
  }
 
  // ----------------------------- Open Modal ----------------------------- //
  openCreateCityModal(content: any) {
    this.isEditMode = false;
    this.createCityForm.reset();
    this.createCityForm.get('cityName')?.enable();
    this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      size: 'md',
    });
  }
 
  openActivePopup(popup: any, city: any): void {
    this.cityId = city.id;
    this.cityStatus = city.cityStatus;
    this.currentCityForStatusChange = { ...city };
    this.modalService.open(popup, { centered: true, backdrop: 'static' });
  }
 
  // ----------------------------- Add City API ----------------------------- //
  addCity(modal: any) {
    this.isPageloading = true
    if (this.isEditMode) {
      const reqBody = {
        cityId: this.selectedCityId,
        coordinateString: this.createCityForm.value.latandlng,
      };
      this.masterService
        .editCoordinates(apiEndPoints.editCoordinates, reqBody)
        .subscribe({
          next: (response: any) => {
            this.isPageloading = false
            this.toastr.success(response.statusText, 'Success', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            });
            modal.close();
            this.createCityForm.reset();
            this.getCityList();
          },
          error: (error) => {
            this.toastr.error(
              'An unexpected error occurred. Please try again later.',
              'Error',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
            this.isPageloading = false
          },
        });
    } else {
      if (this.createCityForm.valid) {
        const cityName = this.createCityForm.value.cityName;
        const coordinateString = this.createCityForm.value.latandlng;
 
        const reqBody = {
          cityName,
          coordinateString,
        };
        console.log(reqBody);
 
        this.masterService
          .postCityApi(apiEndPoints.addCityCoordinates, reqBody)
          .subscribe({
            next: (response: any) => {
              if (response.statusText == 'City Already Exists') {
                this.toastr.warning(
                  'City already exists. Please try another name.',
                  'Warning',
                  {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                    progressBar: true,
                  }
                );
                this.createCityForm.controls['cityName'].setErrors({
                  exists: true,
                });
              } else {
                this.toastr.success(response.statusText, 'Success', {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                });
                modal.close();
                this.createCityForm.reset();
                this.getCityList();
              }
            this.isPageloading = false

            },
            error: (error) => {
              this.toastr.error(
                'An unexpected error occurred. Please try again later.',
                'Error',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
            this.isPageloading = false

            },
          });
      } else {
        this.createCityForm.markAllAsTouched();
        this.toastr.info('Make sure you complete every field.', 'Info', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true,
        });
        this.isPageloading = false
      }
    }
  }
 
  // ----------------------------- Edit city Modal ----------------------------- //
 
  editItem(city: any, modal: any) {
    this.selectedCityId = city.id;
    this.isEditMode = true;
    this.modalService.open(modal, { centered: true, backdrop: 'static' });
    this.createCityForm.patchValue({
      cityName: city.cityName,
      latandlng: city.cityCoordinates,
    });
    this.createCityForm.get('cityName')?.disable();
  }


  // delete city 

deletecity:any = 0

     openDeleteModal(cityID: number, content: any) {
      console.log(cityID,'ID');
      
    this.deletecity = cityID; // store the zone to delete
    this.modalService.open(content, { centered: true });
  }

  deleteZoneByZoneID(modal:any) {
    this.masterService.deleteCity(apiEndPoints.deleteCity, this.deletecity).subscribe({
      next: (response: any) => {
        if (response.statusText == 'Successful') {
          this.toastr.success(
            'City successfully deleted',
            'Success',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
           modal.close(); 
        }
        else {
  this.toastr.warning(
              'Something went wrong , please try again ',
              'Warning',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
             modal.close(); 
        }
        this.getCityList()
      },
      error:(err:any) => {
         this.toastr.warning(
              'Something went wrong , please try again ',
              'Warning',
              {
                timeOut: 3000,
                positionClass: 'toast-top-right',
                progressBar: true,
              }
            );
              modal.close(); // close modal
      }
    })
  }
 
  // ----------------------------- Active & Inactive City API ----------------------------- //
  changeCityStatus(modal: any): void {
    const toggledStatus =
      this.cityStatus === true || this.cityStatus === 'true' ? false : true;
 
    this.masterService
      .postActiveInactiveCity(
        apiEndPoints.activeInactiveCity,
        this.cityId,
        toggledStatus
      )
      .subscribe({
        next: (response: any) => {
          modal.close();
          this.currentCityForStatusChange.cityStatus = toggledStatus;
          this.toastr.success(
            `City "${
              this.currentCityForStatusChange.cityName
            }" status changed to ${
              this.currentCityForStatusChange.cityStatus ? 'Active' : 'Inactive'
            }`,
            'Status Updated',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
          this.getCityList(); // Reload the list after status change
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }
 
  // ----------------------------- Pagination ----------------------------- //
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.cityData?.slice(start, end);
  }
 
  onPageChange(page: number): void {
    this.page = page;
  }
 
  onPageSizeChange(): void {
    this.page = 1;
  }
 
 
  // ------------------------------- Search Filter ------------------------------- //
  search(event: any) {
    const searchText = event.target.value.toLowerCase();
 
    if (!this.originalTableData) {
      this.originalTableData = [...this.cityData];
    }
 
    if (searchText) {
      this.cityData = this.originalTableData.filter((item: any) =>
        item.cityName.toLowerCase().includes(searchText)
      );
    } else {
      this.cityData = [...this.originalTableData];
    }
  }
 
  // ------------------------------- Export to Excel ------------------------------- //
  // exportToExcel(): void {
  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.cityData);
  //   const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
  //   XLSX.writeFile(wb, 'CityList.xlsx');
  // }
 
  exportToExcel(): void {
  // Build data in the same structure as the PDF
  const formattedData = this.cityData.map((city: any, index: number) => {
    const formattedDate = new Date(city.createdDate).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
 
    return {
      'S.No': index + 1,
      'City Name': city.cityName,
      'Date Created': formattedDate,
      'Status': this.getStatus(city.cityStatus),
    };
  });
 
  // Create worksheet with formatted data
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(formattedData);
 
  // Optional: Set column widths for nicer formatting
  ws['!cols'] = [
    { wch: 6 },   // S.No
    { wch: 25 },  // City Name
    { wch: 20 },  // Date Created
    { wch: 15 },  // Status
  ];
 
  // Create workbook and export
  const wb: XLSX.WorkBook = { Sheets: { 'City List': ws }, SheetNames: ['City List'] };
  XLSX.writeFile(wb, 'CityList.xlsx');
}
 
 
  clearGrid(inputElement: HTMLInputElement): void {
    inputElement.value = ''; // ✅ clear text
    this.searchKey = ""
    this.cityData = [...this.originalTableData];
  }
 
  getSerialNumber(index: number): number {
  return (this.page - 1) * this.pageSize + index + 1;
}
  // ------------------------------- Print List or Download PDF ------------------------------- //
 
  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'City_List.pdf';
 
    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
 
      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );
 
        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );
 
        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );
 
          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );
 
          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);
 
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'City List';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });
 
          // Table headers
          const headers = [
            [
               { content: 'S.No' }, // added S.No
              { content: 'City Name' },
              { content: 'Date Created' },
              { content: 'Status' },
            ],
          ];
 
          let tableBody: any[] = [];
          // Ensure Year is filled for every row
          this.cityData.forEach((city: any,index: number) => {
            const formattedDate = new Date(city.createdDate).toLocaleDateString(
              'en-GB',
              {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              }
            );
 
            let status = this.getStatus(city.cityStatus);
 
            tableBody.push([index + 1, city.cityName, formattedDate, status]);
          });
 
          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });
 
          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}